<template>
  <div>
    <portal to="toolbar-title"> Ιστορικό Γεγονότων
      <v-icon>mdi-arrow-right</v-icon>
    </portal>
    <portal to="toolbar-items">
      <v-btn-toggle background-color="transparent" borderless v-model="activeView">
        <v-btn text large value="table">
          <v-icon class="mr-1"> mdi-table</v-icon>
          ΠΙΝΑΚΑΣ
        </v-btn>
        <v-btn text large value="calendar">
          <v-icon class="mr-1"> mdi-calendar</v-icon>
          ΗΜΕΡΟΛΟΓΙΟ
        </v-btn>
      </v-btn-toggle>
    </portal>

    <single-page>
      <template v-slot:toolbar-title>
        Προβολή Γεγονότων
      </template>
      <template v-slot:after-title>
        <v-btn text v-if="activeView==='table'" large color="primary"
               @click="exportToExcel('ΙΣΤΟΡΙΚΟ ΓΕΓΟΝΟΤΩΝ+'+filters.dateFrom+'_'+filters.dateTo)">
          <v-icon> mdi-file-excel</v-icon>
          ΛΗΨΗ EXCEL
        </v-btn>
      </template>
      <template v-slot:toolbar-items>
        <v-row justify="center" align="center" class="pl-5">
          <div style="margin-right: 10px">
            <label style="font-size: 0.7em" for="dateFrom"> Από </label>
            <input style="border-bottom: grey 1px solid; padding-top: 0" id="dateFrom"
                   type="date"
                   v-model="filters.dateFrom" @change="eventDateSearch()">
          </div>
          <div>
            <label style="font-size: 0.7em" for="date" @change="eventDateSearch()"> Eώς </label>
            <input style="border-bottom: grey 1px solid; padding-top: 0" id="date" type="date"
                   v-model="filters.dateTo">
          </div>
        </v-row>
      </template>

      <template v-slot:main-content>
        <v-card>
          <active-filters module-name="DataGridHandler"/>
          <v-data-table v-if="activeView === 'table'" id="table" @click:row="rowClick" :headers="headers"
                        :items="data"
                        disable-pagination hide-default-footer fixed-header height="76vh">
            <template v-slot:item.DateEventInsert="{item}">
              <span v-if="item.EventType_ID === 1">{{ item.DateStart | fullDate }}</span>
              <span v-else> {{ item.DateEventInsert | fullDate }}</span>
            </template>
            <template v-slot:item.EventType_ID="{item}">
              <v-chip outlined v-if="item.EventType_ID === 1" color="maintenance">
                <v-icon> mdi-wrench-outline</v-icon>
                Συντήρηση
              </v-chip>
              <v-chip outlined v-else-if="item.EventType_ID === 2" color="callout" dark>
                <v-icon> mdi-alert-outline</v-icon>
                Βλάβη
              </v-chip>
              <v-chip outlined v-else-if="item.EventType_ID === 3" color="task" dark> Άλλη εργασία
              </v-chip>
            </template>
          </v-data-table>
          <div v-if="activeView === 'calendar'">
            <v-btn
                icon
                class="ma-2"
                @click="$refs.calendar.prev()"
            >
              <v-icon> mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
                icon
                class="ma-2"
                @click="$refs.calendar.next()"
            >
              <v-icon> mdi-chevron-right</v-icon>
            </v-btn>
            <v-calendar
                v-model="value"
                ref="calendar"
                :events="eventCalendar" :type="calendarType"
                v-if="activeView==='calendar'"
                :event-color="(e)=>e.color"
                @click:event="calendarEventClick"
            >

            </v-calendar>

          </div>
        </v-card>
      </template>
      <template v-slot:main-sidebar>
        <filters module-name="DataGridHandler"/>
      </template>
    </single-page>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import store from "../../../store";
import events from "../../../wl-core/api/sectors/events";
import SinglePage from "@/components/templates/SinglePage";
import moment from "moment";
import dataGridHandler from "../../../wl-datagrid-handler/dataGridHandler";
import Filters from "../../../wl-datagrid-handler/Filters";
import ActiveFilters from "../../../wl-datagrid-handler/ActiveFilters";
import EventCard from "../components/EventCard";

export default {
  name: "EventHistoryDesktop",
  components: {SinglePage, ActiveFilters, Filters},
  data: () => ({
    activeView: 'table',
    calendarType: 'month',
    value: '',
    events: [],
    filteredEvents: [],
    filters: {
      dateFrom: moment(Date.now()).subtract(120, 'days').format('YYYY-MM-DD'),
      dateTo: moment(Date.now()).format('YYYY-MM-DD'),
    },

    activeFilters: {
      eventType: null,
      eventBuilding: null,
    },

    eventFilters: {
      eventTypes: [],
      eventCustomers: [],
      eventBuilding: []
    },
    headers: []
  }),
  beforeCreate() {
    store.registerModule('DataGridHandler', dataGridHandler);
  },
  created() {
    this.headers = [
      {
        text: 'Tύπος',
        value: 'EventType_ID',
        filterable: true,
        width: "100"
      },
      {
        text: 'Hμ/νια ',
        value: 'DateEventInsert',
        filterable: true,
        width: "100"
      },

      {
        text: 'Περιγραφή',
        value: 'Description',
        filterable: true,
      },
      {
        text: 'Κτήριο',
        value: 'BranchAddress',
        filterable: true,
        width: "150"
      },
      {
        text: 'Περιοχή',
        value: 'BranchAreaName',
        width: "100"
      },
      {
        width: "120",
        text: this.$unitText('Ανυψωτικό'),
        value: 'ProjectName'
      },
    ]
    this.getAllEvents({LastDays: 60})
        .then(events => {
          this.setEvents(events)
        })
  },
  computed: {
    ...mapGetters('DataGridHandler', [
      "data"
    ]),
    eventCalendar() {
      return this.data.map(e => ({
        name: e.BranchAddress + "-" + e.ProjectName,
        start: new Date(e.getCalendarStart()),
        end: new Date(e.DateEnd),
        color: e.getColor(),
        event: e
      }))
    }
  },
  beforeDestroy() {
    this.$store.unregisterModule('DataGridHandler');
  },
  methods: {

    calendarEventClick({nativeEvent, event}) {
      this.rowClick(event.event)
    },
    rowClick(event) {
      this.$modal.show(EventCard, {eventId: event.Event_ID}, {height: 'auto', width: '70%'});
    },
    setEvents(events) {
      this.events = events;
      this.events.forEach(e => e.EventName = this.getEventName(e.EventType_ID));
      this.setData(this.events);
      this.createFilters([
        {key: 'EventName', name: 'Τύπος'},
        {key: 'BranchAddress', name: 'Κτήρια'},
        {key: 'StatusName', name: 'Κατάσταση'}
      ]);
    },
    eventDateSearch() {
      this.getAllEvents({DateFrom: this.filters.dateFrom, DateTo: this.filters.dateTo}).then(
          events => this.setEvents(events)
      )
    },
    getEventName(number) {
      let names = {1: 'Συντήρηση', 2: 'Βλάβη', 3: 'Άλλη Εργασία'};
      return names[number];
    },
    ...mapActions([
      "exportToExcel",
      "getAllEvents",
    ]),
    ...mapMutations('DataGridHandler', [
      "clearAllFilters",
      "clearFilter",
      "setData",
      "addFilter",
      "createFilters",
    ])
  }
}
</script>

<style scoped>

</style>
